import { render } from "./DuplicateStudentDialog.vue?vue&type=template&id=245ddf66&scoped=true"
import script from "./DuplicateStudentDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateStudentDialog.vue?vue&type=script&lang=js"

import "./DuplicateStudentDialog.vue?vue&type=style&index=0&id=245ddf66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245ddf66"]])

export default __exports__